/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { IM, useTheme } from '@infominds/react-native-components'
import React from 'react'
import { StyleSheet } from 'react-native'

import Colors from '../constants/Colors'
import { TextInput, TouchableOpacity, View } from './Themed'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SearchBar(props: any) {
  const { colorScheme } = useTheme()

  return (
    // eslint-disable-next-line react-native/no-inline-styles
    <View style={{ height: 55 }}>
      <View style={styles.searchbar}>
        <View style={styles.itemLeft}>
          <TextInput
            lightColor={Colors.light.listItemBackground}
            darkColor={Colors.dark.listItemBackground}
            placeholderTextColor={Colors[colorScheme].text}
            placeholder="Search..."
            style={[styles.input, { color: Colors[colorScheme].text }]}
            onChangeText={text => {
              props.onChangeText(text)
            }}
            value={props.text}
          />
        </View>
        <View style={styles.itemRight}>
          {/* eslint-disable-next-line react-native/no-inline-styles */}
          <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
            {/* eslint-disable-next-line react-native/no-inline-styles */}
            <TouchableOpacity style={{ marginRight: 10 }} onPress={props.onGroupPress}>
              <IM.Icon size={28} icon={['far', 'list-radio']} color={Colors[colorScheme].text} />
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  searchbar: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  itemLeft: {
    flex: 1,
  },
  itemRight: {
    padding: 5,
    height: '100%',
    marginTop: 10,
  },
  input: {
    height: 40,
    minHeight: 40,
    margin: 10,
    padding: 10,
    borderWidth: 0,
    borderRadius: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

export default SearchBar
